<template>
  <Section :title="gettext('Votre énergie actuelle')">
    <RadiosGrid
      :value="simulation.energy"
      :field="field"
      grid-item-class="w-1/2 md-w-1/4"
      label-class="box--small"
      @change="(val) => updateSimulation({ energy: val.target.value })"
    >
      <template #default="slotProps">
        <Icon :id="slotProps.choice[1].icon" class="text-brand icon--150" />
        <div class="h5 mrgt-- mrgb0">{{ slotProps.choice[1].label }}</div>
      </template>
    </RadiosGrid>

    <CustomerPortalLink v-if="simulation.energy === 'gas'" />
  </Section>
</template>

<script setup>
import { computed } from 'vue';

import config from '@/config/simulation';
import Section from '@/components/simulation/Section.vue';
import CustomerPortalLink from '@/components/simulation/CustomerPortalLink.vue';
import RadiosGrid from '@/components/forms/fields/RadiosGrid.vue';
import { useSimulation } from '@/composables/useSimulation';

const { simulation, updateSimulation } = useSimulation();

const field = computed(() => {
  return {
    label: gettext('Énergies'),
    name: 'energies',
    choices: Object.keys(config.energies).map((key) => {
      const val = config.energies[key];
      return [key, val];
    }),
  };
});
</script>
